/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedules_Last_Run_NeverInputs */



/**
* | output |
* | --- |
* | "No runs yet" |
*
* @param {Agent_Schedules_Last_Run_NeverInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedules_last_run_never = /** @type {((inputs?: Agent_Schedules_Last_Run_NeverInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedules_Last_Run_NeverInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Läufe")
	return /** @type {LocalizedString} */ ("No runs yet")
});